import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { findProduct } from "@/data/mellow";

const cutout = (p) => (Array.isArray(p.cutout) ? p.cutout[0] : p.cutout || p.img);

export const MiniBasket = () => {
  const { lastAdded, count } = useCart();
  const [show, setShow] = useState(false);
  const product = lastAdded ? findProduct(lastAdded.lookup_key) : null;

  useEffect(() => {
    if (!lastAdded) return;
    setShow(true);
    const t = setTimeout(() => setShow(false), 2800);
    return () => clearTimeout(t);
  }, [lastAdded]);

  if (!show || !product) return null;
  return (
    <Link
      to="/panier"
      className="absolute right-0 top-[calc(100%+10px)] z-50 flex items-center gap-3 rounded-3xl border-2 border-dashed border-[#D1D5CB] bg-[#FFFDF9] pl-2 pr-4 py-2 shadow-[0_14px_40px_rgb(74,59,50,0.18)] animate-pop-in"
      data-testid="mini-basket"
      onClick={() => setShow(false)}
    >
      <span className="relative w-16 h-16 shrink-0">
        <img src="/illustrations/basket.jpg" alt="" className="absolute inset-0 w-full h-full object-contain mix-blend-multiply" draggable={false} />
        <img key={lastAdded.at} src={cutout(product)} alt={product.name} className="absolute left-1/2 top-1/2 w-7 h-auto rounded-[2px] drop-shadow-md animate-drop-in" style={{ "--rot": "-8deg" }} draggable={false} />
      </span>
      <span className="min-w-0">
        <span className="block font-cursive text-xl text-[#78353A] leading-none" data-testid="mini-basket-title">Ajouté au panier ✿</span>
        <span className="block text-xs text-[#4A3B32]/75 truncate max-w-[180px]">{product.name}</span>
        <span className="block mt-0.5 text-xs text-[#78353A] underline decoration-dotted underline-offset-4" data-testid="mini-basket-link">Voir le panier ({count})</span>
      </span>
    </Link>
  );
};
